import pricingData from './data';
import PlanCard from './plan-card/PlanCard';

const PricingPage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isUpgrade = urlParams.get('upgrade') === 'true';
  const projectId = urlParams.get('projectId');

  return (
    <div className="pricing-page-container">
      <div className="pricing-header">
        <h1 className="heading">{pricingData.header.heading}</h1>
        <p className="description">{pricingData.header.description}</p>
      </div>

      <div className="pricing-grid">
        {pricingData.plans
          .filter((plan) => !(isUpgrade && plan.name === 'Free'))
          .map((plan) => (
            <PlanCard
              key={plan.id}
              plan={plan}
              isUpgrade={isUpgrade && plan.name !== 'Free'}
              projectId={projectId || null}
            />
          ))}
      </div>

      <style jsx>{`
        .pricing-page-container {
          margin-top: 64px;
          min-height: 100vh;
          padding: 20px 20px 100px;
        }

        .pricing-header {
          text-align: center;
          max-width: 900px;
          margin: 0 auto 60px;
        }

        .heading {
          font-size: 2.75rem;
          font-weight: 700;
          color: var(--text-color-primary);
          margin: 0 0 12px 0;
          line-height: 1.2;
          letter-spacing: -0.02em;
        }

        .description {
          font-size: 1.125rem;
          color: var(--text-color-primary);
          line-height: 1.6;
          margin: 0;
          font-weight: 500;
        }

        .pricing-grid {
          display: flex;
          justify-content: ${isUpgrade ? 'center' : 'left'};
          align-items: flex-start;
          gap: 28px;
          max-width: 1200px;
          margin: 0 auto;
          flex-wrap: wrap;
        }

        /* Tablet portrait */
        @media (max-width: 768px) {
          .pricing-page-container {
            padding: 50px 20px 60px;
          }

          .pricing-header {
            max-width: 600px;
            margin-bottom: 40px;
          }

          .heading {
            font-size: 2rem;
            margin-bottom: 10px;
          }

          .description {
            font-size: 1rem;
          }

          .pricing-grid {
            flex-direction: column;
            align-items: center;
            gap: 24px;
          }
        }

        /* Mobile */
        @media (max-width: 480px) {
          .pricing-page-container {
            padding: 40px 16px 50px;
          }

          .pricing-header {
            margin-bottom: 32px;
          }

          .heading {
            font-size: 1.75rem;
            letter-spacing: -0.01em;
          }

          .description {
            font-size: 0.9375rem;
            line-height: 1.5;
          }

          .pricing-grid {
            gap: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default PricingPage;
